import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Recording, Filter, Page, SortOption, OrderOption } from './recording.model';
import { ESearchScopes } from 'src/app/search/state/search-term.model';
import { SortOrder } from '../../asset-management/types';
import { SortType } from '../enum';

export interface RecordingsState extends EntityState<Recording> {
  ui: {
    scope: ESearchScopes;
    selectedArtists: string[];
    sort: SortOption;
    sortOrder: OrderOption;
  };
  page: Page;
  filters: Filter[];
  activeFilters: {
    includes: Filter[];
    excludes: Filter[];
  };
  sortOptions: SortOption[];
  orderOptions: OrderOption[];
  requestsCount: number;
}

const initialState = {
  ui: {
    scope: ESearchScopes.RECORDINGS,
    selectedArtists: [],
    sort: { name: SortType.relevance, label: 'Relevancy' },
    sortOrder: { name: SortOrder.desc, label: 'Desc' },
  },
  page: {
    offset: 0,
    total: 1,
    pageSize: 10,
  },
  filters: [],
  sortOptions: [
    { name: SortType.relevance, label: 'Relevancy' },
    { name: SortType.publishingPercent, label: 'Pub Control, %' },
    { name: SortType.releaseYear, label: 'Release Year' },
    { name: SortType.copyrightYear, label: 'Copyright Year' },
    { name: SortType.writer, label: 'Writer' },
    { name: SortType.artist, label: 'Artist' },
    { name: SortType.label, label: 'Label' },
    { name: SortType.title, label: 'Song Title' },
    { name: SortType.albumTitle, label: 'Album Title' },
    { name: SortType.version, label: 'Version' },
  ],
  orderOptions: [
    { name: SortOrder.desc, label: 'Desc' },
    { name: SortOrder.asc, label: 'Asc' },
  ],
  requestsCount: 0,
};

@StoreConfig({
  name: 'Recordings',
  cache: {
    ttl: 3600000,
  },
  resettable: true,
})
@Injectable()
export class RecordingsStore extends EntityStore<RecordingsState, Recording> {
  constructor() {
    super(initialState);
  }

  updateSearchScope(scope: ESearchScopes): void {
    this.update(e => ({ ui: { ...e.ui, scope } }));
  }

  updateSortType(sort: SortOption): void {
    this.update(e => ({
      ui: {
        ...e.ui,
        sort,
      },
    }));
  }

  updateOrderType(sortOrder: OrderOption): void {
    this.update(e => ({
      ui: {
        ...e.ui,
        sortOrder,
      },
    }));
  }

  updatePage(page: Page): void {
    this.update({
      page,
      loading: false,
    });
  }

  updateFilters(filters: Filter[]): void {
    this.update({
      filters,
    });
  }

  updateActiveFilters(activeFilters: { includes: Filter[]; excludes: Filter[] }): void {
    this.update({
      activeFilters,
    });
  }

  inecrementRequestCount(): void {
    this.update(state => ({
      requestsCount: state.requestsCount + 1,
    }));
  }
}
